import {
  SET_PICKUP_FORM,
  UPDATE_PICKUP_FORM,
  PICKUP_FROM_SUBMISSION_SUCCESS,
  SET_ADDRESS_TO_PICKUPFORM,
  SET_CURRENT_STEP_ERROR
} from "../actions/pickupForm";
import locale from '../../utils/locale';

const INITIAL_STATE = {
  fields: {},
  fieldChangeEffects: {},
  errors: {},
  formSubmitted: false,
  statusMessage: '',
  currentStepError: false,
  messageType: 'success'
};

export const pickupFormReducer = (pickupForm = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_PICKUP_FORM:
      return { ...pickupForm, ...action.payload };

    case PICKUP_FROM_SUBMISSION_SUCCESS:
      return { ...INITIAL_STATE, formSubmitted: true, statusMessage: action.payload.message, messageType: action.payload.messageType };

    case UPDATE_PICKUP_FORM:
      return action.payload;

    case SET_CURRENT_STEP_ERROR:
      return { ...pickupForm, currentStepError: action.payload };

    case SET_ADDRESS_TO_PICKUPFORM:
    return {
      ...pickupForm,
      fields:{
        ...pickupForm.fields,
        ...action.payload
      }
    }
    default:
      return pickupForm;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/pickupForm.js